/**
 * Shown when a tenant site is suspended or closed (mirrors the app's
 * /suspended). The tenant's public content isn't served in either state.
 */
const Suspended = () => (
  <div className="min-h-screen flex items-center justify-center bg-background p-6">
    <div className="max-w-md text-center space-y-3">
      <h1 className="text-2xl font-semibold">This site isn't available</h1>
      <p className="text-sm text-muted-foreground">
        This account is currently suspended or closed, so its photos can't be viewed right now. If
        you think this is a mistake, please contact the account owner or{" "}
        <a href="mailto:support@photohawk.com" className="text-primary underline">
          support@photohawk.com
        </a>
        .
      </p>
    </div>
  </div>
);

export default Suspended;
